import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { selectUser, selectGreenhouse, selectZone } from 'state';
import { ROUTES } from '_constants';
import { GreenhouseList } from 'components/GreenhouseList';
import { Header } from 'components/Header';
import { Redirect } from 'react-router-dom';
import { ZoneList } from '../../components/ZoneList';
import { useGreenhouseActions } from 'state';
import { useEffect } from 'react';

export const CoGrower = () => {
  const user = useSelector(selectUser);
  const { selectedGreenhouse, selectedGreenhouseExternalID, selectedGreenhouseTimezone } =
    useSelector(selectGreenhouse);
  const { selectedZone } = useSelector(selectZone);
  const { getLocations } = useGreenhouseActions();

  useEffect(() => {
    getLocations();
  }, [getLocations]);
  const userToken = user?.token;
  if (!userToken) {
    return <Redirect to={ROUTES.ROOT} />;
  }
  if (!selectedGreenhouse && !selectedZone) {
    return <div>No selection</div>;
  }
  const customerId = user?.customer?.[0]?.external_id;
  const baseUrl =
    process.env.REACT_APP_IFRAME_BASE_URL || 'https://portal.groweradviser.com';

  const renderIframe = () => (
    <iframe
      width='100%'
      height='800px'
      src={`${baseUrl}/streamlit_proxy/?user_token=${userToken}&customer_id=${customerId}&location_id=${selectedGreenhouse}&location_external_id=${selectedGreenhouseExternalID}&location_timezone=${selectedGreenhouseTimezone}&zone_id=${selectedZone}&copilot=true`}
    ></iframe>
  );

  return (
    <>
      <Header />
      <GreenhouseList />
      <ZoneList />
      {renderIframe()}
    </>
  );
};
